import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a916dc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-location-page" }
const _hoisted_2 = { class: "selection" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "auto-text ws_ml4" }, "自动刷新", -1))
const _hoisted_5 = { class: "right" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "map-location",
  id: "map-location"
}, null, -1))

import { onMounted, ref, watch, onUnmounted } from 'vue'
import { CODE_ENUM, MAP_TYPE_ENUM, PRODUCT_TYPE } from '@/common'
import L from 'leaflet'
import {
  createMap,
  getMarkClass,
  formatLat,
  formatLng,
  toChina,
} from '@/utils/map.utils'
import SelectDeviceAll from '@/components/select-device-all'
import { queryDeviceLocationBycondit, queryDeviceInfo } from '@/api'
import moment from 'moment'
import { cloneDeep } from 'lodash'
import { ElMessage } from 'element-plus'
import MapControl from '@/components/map-control'
// import '@/lib/marker-fix-move'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const productTypeType = [
  {
    title: '卫星地面站',
    value: PRODUCT_TYPE.SAT_GROUND_STATION,
    iconClass: 'station',
  },
  {
    title: 'LoRa耳标',
    value: PRODUCT_TYPE.LORA,
    iconClass: 'lora',
  },
  {
    title: '卫星多模边缘计算网关',
    value: PRODUCT_TYPE.MULTI_GATEWAY,
    iconClass: 'duomo',
  },
  {
    title: '卫星单模网关',
    value: PRODUCT_TYPE.SINGLE_GATEWAY,
    iconClass: 'danmo',
  },
]

// 已选类型
// const selectproductType = ref(productTypeType.map((item: any) => item.value))
const selectproductType = ref([productTypeType[0].value])


// 根据已选类型重新渲染
watch(
  selectproductType,
  () => {
    renderResult()
  },
  {
    deep: true,
  }
)

const isActive = (value: any) => {
  return selectproductType.value.includes(value)
}

//  产品类型勾选
const select = (value: any) => {
  if (selectproductType.value.includes(value)) {
    selectproductType.value = selectproductType.value.filter((v) => v !== value)
  } else {
    selectproductType.value.push(value)
  }
}

const formInline = ref({
  deviceId: undefined,
})

let map: any = null
onMounted(() => {
  map = createMap('map-location')
  queryLocation()

  map.on('zoomend', () => {
    markerList.value.map((marker: any) => {
      const latLng = marker.getLatLng()
      marker?.setLatLng?.(latLng)
    })
  })
})

const moData = ref({})
const submit = () => {
  moData.value = cloneDeep(formInline.value)
  queryLocation()
}

// 查询结果集合
const resultList = ref([])
const queryLocation = async () => {
  const res: any = await queryDeviceLocationBycondit({
    ...moData.value,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    resultList.value = res.data || []

    fitBounds()
    renderResult()
  }
}

const fitBounds = () => {
  if (resultList.value.length === 0) {
    ElMessage.warning('暂无设备定位')
    toChina(map)
  } else {
    const latlng = resultList.value.map(({ latitude, longitude }: any) => {
      return {
        lng: longitude,
        lat: latitude,
      }
    })
    map.fitBounds(latlng)
  }
}

const markerList: any = ref([])
// 渲染
const renderResult = () => {
  removeAllMarker()
  markerList.value = resultList.value.map((item: any) => {
    const marker = createMark(item)
    // 这里判断是否展示在地图上
    if (selectproductType.value.includes(item.productTypeCode)) {
      marker.addTo(map)
    }
    return marker
  })
}

//移除
const removeAllMarker = () => {
  markerList.value.map((marker: any) => {
    marker?.remove?.()
  })
}

const createMark = (device: any) => {
  const { latitude, longitude, productTypeCode } = device
  const marker = L.marker([latitude, longitude], {
    icon: new L.divIcon({
      iconSize: [34, 41],
      className: getMarkClass(productTypeCode),
      iconAnchor: [18, 40],
    }),
  })

  marker.off('click')
  marker.on('click', async (e: any) => {
    const { latlng } = e
    // map.setView(latlng, 19)
    let data: any = {}
    if (device.productTypeCode !== PRODUCT_TYPE.SAT_GROUND_STATION) {
      data = await queryDetail(device.deviceId)
    }
    const moData: any = {
      ...device,
      ...data,
    }
    const html = getPopupHtml(moData)
    const popup = new L.popup({
      offset: L.point(0, -41),
    }).setContent(html)

    marker.bindPopup(popup)
    marker.openPopup()
  })

  return marker
}

const queryDetail = async (deviceId: any) => {
  return new Promise(async (resolve) => {
    const res: any = await queryDeviceInfo({
      deviceId,
    })
    if (res?.code === 0) {
      resolve({
        deviceAddress: res?.data?.deviceLocationInfo?.deviceAddress,
      })
    }
  })
}

const getPopupHtml = (info: any) => {
  const {
    latitude,
    longitude,
    productTypeCode,
    deviceName,
    deviceAddress,
    updateTime,
  } = info

  let html = `
      <div class='ws_mb4'>${'设备名称'}：${deviceName}</div>
      <div class='ws_mb4'>${'设备定位'}：${deviceAddress || '-'}</div>
      <div class='ws_mb4'>${'纬度'}：${
    formatLat(latitude) + ' ' + latitude + '°'
  }</div>
      <div class='ws_mb4'>${'经度'}：${
    formatLng(longitude) + ' ' + longitude + '°'
  }</div>
     
    `

  if (productTypeCode !== PRODUCT_TYPE.SAT_GROUND_STATION) {
    html += ` <div style="padding-bottom: 6px;">${'更新时间'}：${moment(
      updateTime
    ).format('YYYY-MM-DD HH:mm:ss')}</div>`
  }
  return html
}

// 自动刷新
const autoFetch = ref(false)
const timer: any = ref(0)
watch(autoFetch, () => {
  if (autoFetch.value) {
    clearInterval(timer.value)
    timer.value = setInterval(() => {
      submit()
    }, 1000 * 15)
  } else {
    clearInterval(timer.value)
  }
})

onUnmounted(() => {
  clearInterval(timer.value)
})

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          inline: true,
          model: formInline.value,
          class: "form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "设备名称" }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectDeviceAll), {
                  class: "select",
                  modelValue: formInline.value.deviceId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.deviceId) = $event)),
                  placeholder: "请选择设备",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: submit,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_el_switch, {
          modelValue: autoFetch.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((autoFetch).value = $event)),
          class: "ws_ml25"
        }, null, 8, ["modelValue"]),
        _hoisted_4,
        _createVNode(_component_el_tooltip, {
          class: "box-item",
          effect: "dark",
          content: "每十五秒自动点击查询按钮",
          placement: "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "ws_ml10" }, {
              default: _withCtx(() => [
                _createVNode(_component_InfoFilled)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productTypeType, (item, index) => {
          return _createElementVNode("div", {
            onClick: ($event: any) => (select(item.value)),
            key: index,
            class: _normalizeClass([{
            [item.iconClass]: true,
            active: isActive(item.value),
          }, "icon ws_ml5"])
          }, _toDisplayString(item.title), 11, _hoisted_6)
        }), 64))
      ])
    ]),
    _hoisted_7,
    _createVNode(_unref(MapControl))
  ]))
}
}

})